import { ApiService } from '@b2b/common/services/api/types';
import { PermissionsService } from '@b2b/common/services/permissions';
import { ACMEResponse, TODO } from '@b2b/types/core';
import { StateService } from '@uirouter/angularjs';
import angular, { IFilterService, IScope, ITimeoutService } from 'angular';

TemplatesCreateExceptionsController.$inject = [
  '$scope',
  '$timeout',
  '$state',
  '$filter',
  'ApiService',
  'HelpersService',
  'CalendarService',
  'PermissionsService',
  'GridStateFactory',
  'GridDefinitionFactory',
  'TemplatesService',
];

function TemplatesCreateExceptionsController(
  $scope: IScope & { templatesCreateExceptions: TODO },
  $timeout: ITimeoutService,
  $state: StateService,
  $filter: IFilterService,
  ApiService: ApiService,
  HelpersService: TODO,
  CalendarService: TODO,
  PermissionsService: PermissionsService,
  GridStateFactory: TODO,
  GridDefinitionFactory: TODO,
  TemplatesService: TODO
) {
  const ctrl = {
    model: [],
    isLoaded: false,

    gridState: new GridStateFactory(),
    gridDefinition: new GridDefinitionFactory(),

    viewId: $state.current.name,
    gridName: $state.current.name + '.grid0',

    optionsOverride: {
      data: 'templatesCreateExceptions.model',
      pageSize: 50,
      showFooter: true,
      paginate: true,
      multiselect: false,
      enableRowSelection: false,
      columnDefs: [
        {
          field: 'event.name',
          displayName: 'Name',
        },
        {
          field: 'event.displayDate',
          displayName: 'Event Start',
        },
        {
          field: 'event.displayLastModified',
          displayName: 'Modified',
        },
        {
          field: 'edit',
          displayName: 'Edit',
          onCellNavClick: (row, col) => {
            ctrl.onDblClick(row);
          },
          enableHiding: false,
          cellTemplate:
            '<div class="ui-grid-cell-contents"><a data-permit="EVENT_UPDATE" data-ng-click="grid.appScope.onDblClick(row)"role="link">Edit<span class="sr-only"> Details for {{ row.entity.event.name }}</span></a></div>',
        },
      ],
      appScopeProvider: {
        onDataGridPaginate: (newPageNumber, newPageSize, sortField, sortDirection) => {
          ctrl.onDataGridPaginate(newPageNumber, newPageSize, sortField, sortDirection);
        },
        onDataGridSortChange: (grid, columns, page) => {
          ctrl.onDataGridSortChange(grid, columns, page);
        },
        onDblClick: (item) => {
          ctrl.onDblClick(item.entity.event.id);
        },
      },
    },

    init: function () {
      if ($state.params.id) {
        ctrl.gridDefinition.init(ctrl.gridName, ctrl.optionsOverride, ctrl.viewId, false);

        $scope.$on('$destroy', $scope.$on('DataGrid::UserPreferencesLoaded', ctrl.initData));
      }
    },

    initData: function (e, data) {
      const props = ctrl.gridDefinition.getGridState();

      ctrl.gridState.updateGridState(props.page, props.pageSize, props.sortField, props.sortDirection);
      ctrl.getExceptions();
    },

    getExceptions: function () {
      ApiService.event
        .exceptions($state.params.id, ctrl.gridState.getGridState())
        .then((response) => ctrl.success.getExceptions(response))
        .catch((response) => ctrl.success.getExceptions(response));
    },

    hasExceptions: function () {
      return Array.isArray(ctrl.model) && ctrl.model.length;
    },

    process: function (events) {
      if (Array.isArray(events)) {
        for (let i = 0, ii = events.length; i < ii; i++) {
          events[i].event.displayDate = $filter('date')(
            CalendarService.parseDate(events[i].event.startTime),
            HelpersService.dateFormats.sortDateTime
          );
          events[i].event.displayLastModified = $filter('date')(
            CalendarService.parseDate(events[i].event.lastModified),
            HelpersService.dateFormats.sortDateTime
          );
        }
      }

      return events;
    },

    gridDoubleClick: function (item) {
      $state.go('application.programsInstance', { id: item.entity.event.id });
    },

    success: {
      init: function (response) {},
      getExceptions: function (response: { data: ACMEResponse<TODO> }) {
        // next tick
        $timeout(() => {
          ctrl.model = ctrl.process(response.data.payload.list);

          ctrl.isLoaded = true;
          ctrl.gridDefinition.isLoaded = true;
          TemplatesService.setIsTabLoading(false, 'exceptions');

          if (ctrl.hasExceptions()) {
            $scope.$emit('TemplatesCreateController::TabCheck', {
              tab: 'exceptions',
              invalid: true,
            });
          }

          $timeout(function () {
            $scope.$broadcast('DataGrid::ResizeGrid', {
              name: ctrl.gridDefinition.options.gridName,
              datasetLength: ctrl.model.length,
              totalItems: response.data.payload.pagination.count,
            });
          }, 10);
        }, 0);
      },
    },

    error: {
      init: function (response) {
        ctrl.isLoaded = true;
        TemplatesService.setIsTabLoading(false, 'exceptions');
      },
    },

    onDblClick: function (item) {
      if (!item.entity.event.manuallyDeleted) {
        $state.go('application.programsInstanceEdit', { id: item.entity.event.id });
      }
    },

    onDataGridPaginate: function (newPage, pageSize, sortField, sortDirection) {
      ctrl.gridState.updateGridState(newPage, pageSize);
      if (sortField) {
        ctrl.gridState.updateGridState(null, null, sortField, null);
      }
      if (sortDirection) {
        ctrl.gridState.updateGridState(null, null, null, sortDirection);
      }
      ctrl.getExceptions();
    },

    onDataGridSortChange: function (grid, columns, page) {
      const data = columns[0];
      let field = '';

      // Use correct sort field
      switch (data.field) {
        case 'event.displayDate':
          field = 'startTime';
          break;
        case 'event.displayLastModified':
          field = 'lastModified';
          break;
        case 'event.name':
          field = 'name';
          break;
        default:
          field = 'name';
          break;
      }

      ctrl.gridState.updateGridState(page || null, null, field, data.sort.direction);
      ctrl.getExceptions();
    },
  };

  $scope.templatesCreateExceptions = ctrl;
  ctrl.init();
}

export const TemplatesCreateExceptionsControllerModule = angular
  .module('acme.view.application.templates.create.exceptions.controllers', [
    'ui.router',
    'acme.common.service.api',
    'acme.common.service.helpers',
    'acme.common.service.calendar',
    'acme.common.service.permissions',
    'acme.common.service.templates',
    'acme.common.factory.gridState',
    'acme.common.factory.gridDefinition',
  ])
  .controller('TemplatesCreateExceptionsController', TemplatesCreateExceptionsController).name;
